import { IonContent, IonHeader, IonPage, IonCard, IonCardHeader, IonCardContent, IonGrid, IonRow, IonCol, } from '@ionic/vue';
import LanguageSelector from '@/components/list-items/LanguageSelector.vue';
import RepresentationSelection from '@/components/list-items/RepresentationSelection.vue';
import { defineComponent, computed, ref } from 'vue';
import AppToolbar from '@/components/app-structure/AppToolbar.vue';
import LoginButton from '@/components/list-items/LoginButton.vue';
import CampusButton from '@/components/list-items/CampusButton.vue';
import ClickAndLearnButton from '@/components/list-items/ClickAndLearnButton.vue';
import UserInfoSettings from '@/components/list-items/UserInfoSettings.vue';
import { useStore } from "vuex";
import ChangePasswordButton from "@/components/ChangePasswordButton.vue";
import AppFooter from "@/components/app-structure/AppFooter.vue";
export default defineComponent({
    setup() {
        const store = useStore();
        const representation = ref('system');
        const changeRepresentation = (value) => {
            console.log('Change representation', value);
        };
        return {
            isAuthenticated: computed(() => store.state.isAuthenticated),
            changeRepresentation,
            representation
        };
    },
    components: {
        ChangePasswordButton,
        IonContent,
        IonHeader,
        IonPage,
        LanguageSelector,
        RepresentationSelection,
        AppToolbar,
        LoginButton,
        CampusButton,
        ClickAndLearnButton,
        UserInfoSettings,
        IonCard,
        IonCardHeader,
        IonCardContent,
        IonGrid,
        IonRow,
        IonCol,
        AppFooter
    }
});
